import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const MobileModalContainer = styled.div`
  display: none;
  ${media.phone`
    display: block;
  `}
`;

export const CloseAction = styled.span``;

export const AnonHeader = styled.span`
  display: flex;
  justify-content: space-between;
`;
